import { postRecommend } from '@doda/common/src/services/postRecommend';
import { B4rTsuukaAbTestPattern } from '../../types/analytics';
import {
  getApplicationEffectName,
  getApplicationRecommendType,
} from '../b4rTsuukaRecommend';

/**
 * おすすめ求人を取得
 * @param conditionItems 検索結果一覧の上から最大5件の求人ID
 * @param b4rTsuukaABTestPattern AB test type for B4R recommend
 * @returns おすすめ求人
 */
export const getRecommendPanel = async (
  conditionItems: string[],
  b4rTsuukaABTestPattern: B4rTsuukaAbTestPattern
) => {
  const res = await postRecommend({
    recommendType: `${getApplicationRecommendType(b4rTsuukaABTestPattern)},AWS_Recommend_etsuran,view_list`,
    dispType: 'json',
    effectEventId: 'event70,event70,event70',
    effectPosition: 'Rekome_pc,Rekome_pc,Rekome_pc',
    effectName: `${getApplicationEffectName(b4rTsuukaABTestPattern, 'KensakuKekka_Rekome_b4r_cbm_gousei_rerank_recommend', 'KensakuKekka_Rekome_Oubo_ChikaiKyujin_pc')},KensakuKekka_Rekome_Etsuran_ChikaiKyujin_pc,KensakuKekka_Rekome_Etsuran_Kyujin_pc`,
    conditionItems: conditionItems.join(),
    location: window.location.href,
  });

  return res.data;
};

/**
 * おすすめの取得に失敗した際に取得する求人
 * @param b4rTsuukaABTestPattern AB test type for B4R recommend
 * @returns おすすめの取得に失敗した際のおすすめ求人
 */
export const getDefaultRecommendPanel = async (
  b4rTsuukaABTestPattern: B4rTsuukaAbTestPattern
) => {
  const res = await postRecommend({
    recommendType: `${getApplicationRecommendType(b4rTsuukaABTestPattern)},AWS_Recommend_etsuran,view_list,ranking_ocl,ranking_all`,
    dispType: 'json',
    effectEventId: 'event70,event70,event70,event70,event70',
    effectPosition: 'Rekome_pc,Rekome_pc,Rekome_pc,Rekome_pc,Rekome_pc',
    effectName: `${getApplicationEffectName(b4rTsuukaABTestPattern, 'default_KensakuKekka_Rekome_b4r_cbm_gousei_rerank_recommend', 'default_AWS_Recommend_oubo')},default_AWS_Recommend_etsuran,default_view_list,default_ranking_ocl,default_ranking_all`,
    location: window.location.href,
  });

  return res.data;
};
